<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 引入返回顶部 组件
import { site } from "./api/user";

export default {
  name: "App",
  data() {
    return {
      darkTheme: {
        id: 1,
        layout1: "#1F1F1F", //  主题背景色
        layout2: "#FAFAFAAA", // 主题字色
        layout3: "#FAFAFAAA", // 左侧小标题颜色
        layout4: "#F7D274", // 左侧背景色
        layout5: "rgba(247,210,116,0.1)", // 左侧选中背景颜色
        layout6: "#0D1027", // 边框颜色
        layout7: "#FAFAFA", // 备案色
        layout8: "#303346", // 上底边框颜色
        // layoutIcon3:'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组50.png',
        // layoutIcon5:"https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组51.png",
        // layoutIcon7:'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组52.png',
        // layoutIcon8:'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组53.png',
        // layoutIcon23:'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组54.png',
        // layoutIcon10:'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组50.png',
        // layoutIcon12:'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组50.png',
        layoutIcon1:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组64.png", // 左侧图标
        layoutIcon2:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组81.png", // 左侧图标
        layoutIcon3:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组82.png", // 左侧图标
        layoutIcon4:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组49.png", // 左侧图标
        layoutIcon5:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组65.png", // 左侧图标
        layoutIcon6:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组50.png", // 左侧图标
        layoutIcon7:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组66.png", // 左侧图标
        layoutIcon8:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组51.png", // 左侧图标
        layoutIcon9:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组68.png", // 左侧图标
        layoutIcon10:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组53.png", // 左侧图标
        layoutIcon11:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组69.png", // 左侧图标
        layoutIcon12:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组54.png", // 左侧图标
        // layoutIcon13: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组54.png', // 左侧图标
        // layoutIcon14: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组54.png', // 左侧图标

        // layoutIcon15: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/Icon_Phone.png', // 上右电脑手机图标
        // layoutIcon16: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/Icon_Message.png', // 上右消息通知

        // layoutIcon17: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_DuoChangJing2.png?v2', // 多场景选中
        // layoutIcon18: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_DuoChangJing1.png?v2', // 多场景默认

        // layoutIcon19: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_ChongWu2.png', // 宠物选中
        // layoutIcon20: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_ChongWu1.png', // 宠物默认

        // layoutIcon21: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_YingYong1.png', // 应用商店选中
        // layoutIcon22: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_YingYong2.png', // 应用商店默认

        layoutIcon23:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组67.png", // 复刻
        layoutIcon24:
          "https://fenshen123.oss-cn-shenzhen.aliyuncs.com/allOEMWechat/yinBaoHuoKe-pc/编组52.png", // 复刻

        // layoutIcon25: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_aizs2.png', // 超级助手
        // layoutIcon26: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_aizs1.png', // 超级助手

        // layoutIcon27: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_Sucai1.png', // 我的素材
        // layoutIcon28: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_Sucai2.png', // 我的素材

        // layoutIcon29: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_Yuangong1.png', // AI超级员工
        // layoutIcon30: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcDarkImages/Left_Icon_Yuangong2.png', // Ai超级员工

        // // 后面同
        // homeColor1: '#01FBF5',  // 数字演员，数字音频颜色，选中
        // homeColor2: '#FAFAFA', // 数字演员，数字音频颜色，未选中
        // homeColor3: '#FFFFFF', // 横板竖版，选中颜色
        // homeColor4: '#EEEEEEAA', // 横板竖版，未选中
        // homeColor5: '#6C14FF', // 横板竖版，选中背景色

        // homeColor6: '#0E1126', // 横板竖版，未选中背景色
        // homeColor7: '#24273c', // 音频边框颜色和音频描述字色
        // homeColor8: '#FAFAFA', // 音频名字字色
        // homeColor9: '#FAFAFAAA', // 音频描述字色
        // homeColor10: '#24273c', // 音频框子背景色

        // createColor1: '#FAFAFA', // 创建页面主要颜色
        // createColor2: '#323547', // 恢复默认 确认按钮的颜色
        // createColor3: '#FAFAFAAA', // 恢复默认 确认按钮的字色
        // createIcon1: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_Recover.png', // 恢复默认的图标
        // createColor4: '#1f2237', // 音频progress的背景色
        // createIcon2: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Video_Bg.png', // 选中视频的背景图

        // createColor5: '#FFFFFF', // 音频驱动，文本驱动选中字色
        // createColor6: '#FFFFFFAA', // 音频驱动，文本驱动未选中字色
        // createIcon3: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/21_Icon_Text1.png', // 文本选中按钮
        // createIcon4: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/21_Icon_Text2.png', // 文本未选中按钮
        // createIcon5: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_Voice2.png', // 音频选中按钮
        // createIcon6: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_Voice1.png', // 音频未选中按钮
        // createColor7: '#EEEEEE', // 试听帮写文案润色背景色
        // createColor8: '#333333', // 试听帮写文案润色字色
        // createColor9: '#FAFAFA', // 音频框里面desc
        // createColor10: '#35383e', // 文本驱动 音频驱动背景色

        // createIcon7: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_Audition.png', //试听按钮
        // createIcon10: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_AuditionZting.png', //试听按钮
        // createIcon8: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_Text.png', //文案润色
        // createIcon9: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_AI.png', //AI帮写

        // voiceColor1: '#24273c', // 音频边框颜色
        // voiceColor2: '#24273c', // 音频背景色
        // voiceColor3: '#FFFFFF', // 音频字色
        // voiceColor4: '#FFFFFFAA', // 描述字色

        // worksColor1: '#F5F5F5', // 作品全局背景色
        // worksColor2: '#FFFFFF', //  名字（我的作品）
        // worksColor22: '#FFFFFFAA', //  名字（我的作品）

        // consumColor1: '#1f2237', // 背景色
        // consumColor2: '#fafafa', // 文字颜色1
        // consumColor3: '#fafafaAA', // 文字颜色2
        // consumColor4: '#01f7f2', // 文字颜色3
        // consumColor5: '#0D1027', // 积分全局背景色
        // consumColor6: '#36394B', // 每条积分的borderBottom

        // useColor1: '#26283D', // 使用指南选择框未选中背景色
        // useColor2: '#B4B4BB', // 使用指南选择框 未选中颜色
        // useColor3: '#6C14FF', // 使用指南选择框 选中背景色
        // useColor4: '#ffffff', // 使用指南选择框 选中颜色
        // useColor5: '#FAFAFAAA', // 视频下文字颜色
      },
      // lightTheme: {
      //   id: 2,
      //   layout1: '#FFFFFF',      //  主题背景色
      //   layout2: '#222222',     // 主题字色
      //   layout3: '#999999',    // 左侧小标题颜色
      //   layout4: '#6C14FF',   // 左侧背景色
      //   layout5: '#F0E7FF',  // 左侧选中颜色
      //   layout6: '#DCDCDC', // 边框颜色
      //   layout7: '#222222AA',
      //   layout8: '#DCDCDC', // 上底边框颜色
      //   layoutIcon1: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Home1.png', // 左侧图标
      //   layoutIcon2: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Home2.png', // 左侧图标
      //   layoutIcon3: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Video1.png', // 左侧图标
      //   layoutIcon4: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Video2.png', // 左侧图标
      //   layoutIcon5: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_People1.png', // 左侧图标
      //   layoutIcon6: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_People2.png', // 左侧图标
      //   layoutIcon7: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Voice1.png', // 左侧图标
      //   layoutIcon8: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Voice2.png', // 左侧图标
      //   layoutIcon9: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Works1.png', // 左侧图标
      //   layoutIcon10: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Works2.png', // 左侧图标
      //   layoutIcon11: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Points1.png', // 左侧图标
      //   layoutIcon12: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Points2.png', // 左侧图标
      //   layoutIcon13: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Tips1.png', // 左侧图标
      //   layoutIcon14: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Left_Icon_Tips2.png', // 左侧图标

      //   layoutIcon15: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Icon_Phone.png', // 上右电脑手机图标
      //   layoutIcon16: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/Icon_Message.png', // 上右消息通知

      //   layoutIcon17: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_DuoChangJing1.png?v2', // 多场景选中
      //   layoutIcon18: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_DuoChangJing2.png?v2', // 多场景默认

      //   layoutIcon19: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_ChongWu2.png', // 宠物选中
      //   layoutIcon20: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_ChongWu1.png', // 宠物默认

      //   layoutIcon21: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_YingYong2.png', // 应用商店选中
      //   layoutIcon22: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_YingYong1.png', // 应用商店默认

      //   layoutIcon23: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_Fuke1.png', // 复刻
      //   layoutIcon24: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_Fuke2.png', // 复刻

      //   layoutIcon25: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_aizs1.png', // 超级助手
      //   layoutIcon26: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_aizs2.png', // 超级助手

      //   layoutIcon27: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_Sucai1.png', // 我的素材
      //   layoutIcon28: 'https://fenshen123.oss-cn-shenzhen.aliyuncs.com/pcWhiteImages/Left_Icon_Sucai2.png', // 我的素材
      //   // 后面同
      //   homeColor1: '#222222',  // 数字演员，数字音频颜色，选中
      //   homeColor2: '#222222AA', // 数字演员，数字音频颜色，未选中
      //   homeColor3: '#6C14FF', // 横板竖版，选中颜色
      //   homeColor4: '#999999', // 横板竖版，未选中
      //   homeColor5: '#FFFFFF', // 横板竖版，选中背景色
      //   homeColor6: '#EEEEEE', // 横板竖版，未选中背景色
      //   homeColor7: '#DCDCDC', // 音频边框颜色和音频描述字色
      //   homeColor8: '#333333', // 音频名字字色
      //   homeColor9: '#333333AA', // 音频名字字色
      //   homeColor10: '#FFFFFF', // 音频框子背景色

      //   createColor1: '#222222', // 创建页面主要颜色
      //   createColor2: '#EEEEEE', // 恢复默认 确认按钮的颜色
      //   createColor3: '#333333', // 恢复默认 确认按钮的字色
      //   createIcon1: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Icon_Recover.png', // 恢复默认的图标
      //   createColor4: '#F5F5F5', // 音频progress的背景色
      //   createIcon2: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Video_Bg.png', // 选中视频的背景图

      //   createColor5: '#222222', // 音频驱动，文本驱动选中字色
      //   createColor6: '#222222AA', // 音频驱动，文本驱动未选中字色
      //   createIcon3: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/21_Icon_Text1.png', // 文本选中按钮
      //   createIcon4: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/21_Icon_Text2.png', // 文本未选中按钮
      //   createIcon5: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Icon_Voice1.png', // 音频选中按钮
      //   createIcon6: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Icon_Voice2.png', // 音频未选中按钮
      //   createColor7: '#EEEEEE', // 试听帮写文案润色背景色
      //   createColor8: '#333333', // 试听帮写文案润色字色
      //   createColor9: '#DCDCDC', // 音频框里面desc
      //   createColor10: '#EEEEEE', // 文本驱动 音频驱动背景色

      //   createIcon7: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Icon_Audition.png', //试听按钮
      //   createIcon10: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcDarkImages/2.1_Icon_AuditionZt.png', //试听暂停按钮
      //   createIcon8: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Icon_Text.png', //文案润色
      //   createIcon9: 'https://xcyq.oss-cn-qingdao.aliyuncs.com/pcWhiteImages/2.1_Icon_AI.png', //AI帮写

      //   voiceColor1: '#DCDCDC', // 音频边框颜色
      //   voiceColor2: '#ffffff', // 音频背景色
      //   voiceColor3: '#333333', // 音频字色
      //   voiceColor4: '#333333AA', // 描述字色

      //   worksColor1: '#F5F5F5', // 作品全局背景色
      //   worksColor2: '#222222', //  名字（我的作品）
      //   worksColor22: '#222222AA', //  名字（我的作品）

      //   consumColor1: '#ffffff', // 背景色
      //   consumColor2: '#333333', // 文字颜色1
      //   consumColor3: '#999999', // 文字颜色2
      //   consumColor4: '#652EBE', // 文字颜色3
      //   consumColor5: '#F5F5F5', // 积分全局背景色
      //   consumColor6: '#EEEEEE', // 每条积分的borderBottom

      //   useColor1: 'rgba(0,0,0,0.1)', // 使用指南选择框未选中背景色
      //   useColor2: 'rgba(255,255,255,0.1)', // 使用指南选择框 未选中颜色
      //   useColor3: '#6C14FF', // 使用指南选择框 选中背景色
      //   useColor4: '#ffffff', // 使用指南选择框 选中颜色
      //   useColor5: '#000000AA', // 视频下文字颜色
      // },
    };
  },
  beforeMount() {
    // 保存时间戳
    this.updateDynamicFavicon();
    // this.$store.dispatch("updateTheme", this.darkTheme);
    // this.$store.dispatch('updateTheme', this.lightTheme);
  },
  mounted() {
    this.$store.dispatch("getOemInfo");
  },
  methods: {
    setTheme(theme) {
      this.$store.dispatch("updateTheme", this.darkTheme);
    },

    async updateDynamicFavicon() {
      try {
        // 假设你有一个API接口，返回新的favicon的URL
        const response = await site();
        const siteObj = {
          siteTitle: response.data.site_title
            ? response.data.site_title
            : "AI引爆获客",
          cloneUsage: response.data.clone_usage
            ? response.data.clone_usage
            : "https://s.xingchaoyiqing.com/doc/xcyq/eula.html",
        };
        window.localStorage.setItem("siteJson", JSON.stringify(siteObj));
        await this.setTheme(response.data.theme);
        window.localStorage.setItem("siteTheme", response.data.theme);
        const newFaviconUrl = response.data;
        // console.log('newFaviconUrl',newFaviconUrl)
        // 获取当前页面的favicon link标签
        let link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        // 更新href属性为新的图标URL
        link.href = newFaviconUrl.logo;
        // 如果link标签原本不存在，则添加到head中
        if (!document.querySelector("link[rel*='icon']")) {
          document.getElementsByTagName("head")[0].appendChild(link);
        }
      } catch (error) {
        console.error("更新favicon失败:", error);
      }
    },
  },
};
</script>

<style>
#app {
  width: 100vw;
  height: 100vh;
  /*background-color: #0D1027;*/
  overflow: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

#app::-webkit-scrollbar {
  width: 0; /* Chrome, Safari 和其他Webkit浏览器 */
  height: 0;
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue